import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import spread from "../../images/svg/spread.svg";
import { getAracItemData, getUyeItemData } from "../../features/uyelerAraclar/uyelerAraclarSlice";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { profilSurucuSilme } from "../../features/companyProfile/companyProfileSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .detay {
        position: absolute;
        right: 20px;
        top: 10px;
        width: 200px;
        height: 30px;
        cursor: pointer;
        display: flex;
        flex-direction: row-reverse;
        gap: 10px;
        align-items: center;
        p{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          color: var(--color-main);
        }
      }
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
        }
      }
    }
  }
`;

const ProfilimSuruculerContainer = ({ data, toggleMore, isMoreActive }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div onClick={(e) => {e.stopPropagation(); toggleMore(data)}} className="detay" >
            <img src={spread} alt="" />
            {
              isMoreActive === data &&
              <p onClick={() => dispatch(profilSurucuSilme(data.id))}>Sil</p>
            }
          </div>
          <div className="row">
            <div className="col">{data.adSoyadUnvan}</div>
            <div className="col">{data.phoneNumber}</div>
            <div className="col">{data.il}/{data.ilce}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ProfilimSuruculerContainer;
